import { useNavigate } from "react-router-dom";
import { FilePen, Sparkles, Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { boostContentOf, hasContent, ideasOf, optimizedOf, stashTailor, tailorUrl } from "@/lib/tailor";

export const TailorCard = ({ res, tool, jobId, job, onClose }) => {
  const navigate = useNavigate();
  if (!res) return null;
  const ideas = ideasOf(res);
  const optimized = optimizedOf(res);
  if (!ideas.length && !optimized && !hasContent(boostContentOf(res))) return null;
  const go = (useOptimized) => {
    stashTailor({ jobId, job: job ? { title: job.title, company: job.company } : null, toolId: tool?.id, toolTitle: tool?.title, ideas, content: boostContentOf(res), optimized: useOptimized ? optimized : null });
    onClose?.();
    navigate(tailorUrl(jobId));
  };
  const where = job?.title ? `${job.title}${job.company ? ` · ${job.company}` : ""}` : jobId ? "this job" : "your resume";
  return (
    <div className="fade-up relative mt-4 overflow-hidden rounded-xl border border-[#D4AF37]/40 bg-gradient-to-br from-[#D4AF37]/10 via-[#141417] to-[#141417] p-4" data-testid="tailor-card">
      <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-[#D4AF37]/10 blur-2xl" />
      <div className="relative flex items-start gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#D4AF37]/15"><FilePen className="h-4 w-4 text-[#D4AF37]" /></span>
        <div className="min-w-0 flex-1">
          <p className="font-display text-sm font-semibold text-zinc-100">Tailor your resume</p>
          <p className="mt-0.5 break-words text-xs text-zinc-400" data-testid="tailor-card-summary">
            {ideas.length > 0 && <><span className="font-mono text-[#F3C649]">{ideas.length}</span> optimization idea{ideas.length === 1 ? "" : "s"} for {where}. </>}
            {optimized && "An optimized resume is ready to review."}
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            {optimized && <Button size="sm" onClick={() => go(true)} data-testid="tailor-use-optimized"><Wand2 className="h-4 w-4" />Use optimized version</Button>}
            <Button size="sm" variant={optimized ? "outline" : "default"} onClick={() => go(false)} data-testid="tailor-open-studio"><Sparkles className="h-4 w-4" />{ideas.length ? "Apply ideas in Resume Studio" : "Edit in Resume Studio"}</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
